import auth from '@/api/auth'

export default {
  getToken ({ commit }, payload) {
    return auth.getToken(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          commit('CLEAR_LOCAL_STORAGE_DATA')
          commit('CLEAR_AUTH_DATA')
          commit('SET_AUTH_DATA', response.data)
        }
      })
  },
  refreshToken ({ commit, getters }) {
    const refreshToken = getters.getAuthRefreshTokenData
    const payload = { refreshToken }
    return auth.refreshToken(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          commit('CLEAR_AUTH_DATA')
          commit('SET_AUTH_DATA', response.data)
        }
      })
  },
  removeToken ({ commit }) {
    return new Promise((resolve, reject) => { resolve(true) })
  },
  recoveryPassword ({ commit }) {
    return auth.recoveryPassword()
      .then(response => {
        return response
      })
  },
  resetPassword ({ commit }, payload) {
    return auth.resetPassword(payload)
      .then(response => {
        return response
      })
  },
  confirmResetPassword ({ commit }, payload) {
    return auth.confirmResetPassword(payload)
      .then(response => {
        return response
      })
  }
}
